import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Notifications = () => {
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [moreActivity, setMoreActivity] = useState(true);
  const [mobileNotifications, setMobileNotifications] = useState(true); // New state for mobile notifications

  // State for checkboxes
  const [emailSettings, setEmailSettings] = useState({
    newsUpdates: true,
    offersPromotions: true,
    tipsTutorials: true,
  });

  const [activitySettings, setActivitySettings] = useState({
    allReminders: true,
    activityOnly: true,
    importantReminders: true,
  });

  const [mobileSettings, setMobileSettings] = useState({
    // New settings for mobile notifications
    newMessages: true,
    appUpdates: true,
    nearbyOffers: true,
  });

  // Toggle Email Notifications
  const toggleEmailNotifications = () => {
    setEmailNotifications(!emailNotifications);
    if (!emailNotifications) {
      setEmailSettings({
        newsUpdates: true,
        offersPromotions: true,
        tipsTutorials: true,
      });
    } else {
      setEmailSettings({
        newsUpdates: false,
        offersPromotions: false,
        tipsTutorials: false,
      });
    }
  };

  // Toggle More Activity
  const toggleMoreActivity = () => {
    setMoreActivity(!moreActivity);
    if (!moreActivity) {
      setActivitySettings({
        allReminders: true,
        activityOnly: true,
        importantReminders: true,
      });
    } else {
      setActivitySettings({
        allReminders: false,
        activityOnly: false,
        importantReminders: false,
      });
    }
  };

  // Toggle Mobile Notifications
  const toggleMobileNotifications = () => {
    // New toggle for mobile notifications
    setMobileNotifications(!mobileNotifications);
    if (!mobileNotifications) {
      setMobileSettings({
        newMessages: true,
        appUpdates: true,
        nearbyOffers: true,
      });
    } else {
      setMobileSettings({
        newMessages: false,
        appUpdates: false,
        nearbyOffers: false,
      });
    }
  };

  // Handle individual checkbox change for email settings
  const handleEmailCheckboxChange = (e) => {
    setEmailSettings({
      ...emailSettings,
      [e.target.name]: e.target.checked,
    });
  };

  // Handle individual checkbox change for activity settings
  const handleActivityCheckboxChange = (e) => {
    setActivitySettings({
      ...activitySettings,
      [e.target.name]: e.target.checked,
    });
  };

  // Handle individual checkbox change for mobile settings
  const handleMobileCheckboxChange = (e) => {
    // New handler for mobile settings
    setMobileSettings({
      ...mobileSettings,
      [e.target.name]: e.target.checked,
    });
  };

  return (
    <div className="flex bg-gray-100">
      {/* Sidebar */}
      <div className="w-1/5 bg-gray-100 border-r text-black hover:text-gray-800 p-4">
        <h1 className="text-xl font-bold mb-4">Settings</h1>
        <div>
          {/* Sidebar Links */}
          <Link
            to="/dashboard/system-config/wide-settings"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            General
          </Link>
          <Link
            to="/dashboard/system-config/preferences"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Preferences
          </Link>

          <Link
            to="/dashboard/system-config/notifications"
            className="w-full block text-left py-2 px-4 mb-2 rounded bg-black text-white "
          >
            Notifications
          </Link>

          <Link
            to="/dashboard/system-config/language"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Language Settings
          </Link>

          <Link
            to="/dashboard/system-config/currency"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Currency Settings
          </Link>

          <Link
            to="/dashboard/system-config/hotel-config"
            className="w-full block text-left py-2 px-4 mb-2 rounded hover:bg-gray-200"
          >
            Hotel Configuration
          </Link>
        </div>
      </div>

      {/* Main Content */}
      <div className="w-5/6 bg-gray-50 p-8 flex flex-col justify-start">
        {/* Header */}
        <div className="mb-6">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-2xl text-black font-bold">Settings &gt; Notifications</h2>
              <p className="text-gray-500 font-semibold">
                Get Notified about what's happening right now.
              </p>
            </div>
            <div className="flex space-x-4">
              <button className="px-6 py-2 bg-cyan-500 text-white text-sm font-semibold rounded shadow-md hover:text-black transition-all">
                Save
              </button>
              <button className="px-6 py-2 bg-red-500 text-white text-sm font-semibold rounded shadow-md hover:text-black transition-all">
                Cancel
              </button>
            </div>
          </div>
        </div>

        {/* Notifications Section */}
        <div className="bg-white p-6 flex-grow">
          <h1 className="text-xl font-bold text-black">Notifications</h1>
          <p className="text-gray-500 font-semibold">
            Get Notified about what's happening right now.
          </p>
          <hr className="border-t border-gray-300 mt-1 mb-6" />

          {/* Email Notifications */}
          <div className="mb-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Email Notifications</h2>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={emailNotifications}
                  onChange={toggleEmailNotifications}
                />
                <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
              </label>
            </div>
            <div className="pl-4 space-y-4">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  name="newsUpdates"
                  checked={emailSettings.newsUpdates}
                  onChange={handleEmailCheckboxChange}
                  disabled={!emailNotifications}
                  className="h-5 w-5"
                />
                <span className="text-gray-700">News and update settings</span>
              </div>
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  name="offersPromotions"
                  checked={emailSettings.offersPromotions}
                  onChange={handleEmailCheckboxChange}
                  disabled={!emailNotifications}
                  className="h-5 w-5"
                />
                <span className="text-gray-700">Offers and promotions</span>
              </div>
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  name="tipsTutorials"
                  checked={emailSettings.tipsTutorials}
                  onChange={handleEmailCheckboxChange}
                  disabled={!emailNotifications}
                  className="h-5 w-5"
                />
                <span className="text-gray-700">Tips and Tutorials</span>
              </div>
            </div>
          </div>

          {/* More Activity */}
          <div className="mb-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">More Activity</h2>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={moreActivity}
                  onChange={toggleMoreActivity}
                />
                <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
              </label>
            </div>
            <div className="pl-4 space-y-4">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  name="allReminders"
                  checked={activitySettings.allReminders}
                  onChange={handleActivityCheckboxChange}
                  disabled={!moreActivity}
                  className="h-5 w-5"
                />
                <span className="text-gray-700">All reminders and activity</span>
              </div>
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  name="activityOnly"
                  checked={activitySettings.activityOnly}
                  onChange={handleActivityCheckboxChange}
                  disabled={!moreActivity}
                  className="h-5 w-5"
                />
                <span className="text-gray-700">Activity Only</span>
              </div>
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  name="importantReminders"
                  checked={activitySettings.importantReminders}
                  onChange={handleActivityCheckboxChange}
                  disabled={!moreActivity}
                  className="h-5 w-5"
                />
                <span className="text-gray-700">Important reminders</span>
              </div>
            </div>
          </div>

          {/* Mobile Notifications (New section) */}
          <div className="mb-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Mobile Notifications</h2>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={mobileNotifications}
                  onChange={toggleMobileNotifications}
                />
                <div className="w-11 h-6 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-blue-600 rounded-full peer-checked:bg-blue-600 peer-checked:after:translate-x-5 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"></div>
              </label>
            </div>
            <div className="pl-4 space-y-4">
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  name="newMessages"
                  checked={mobileSettings.newMessages}
                  onChange={handleMobileCheckboxChange}
                  disabled={!mobileNotifications}
                  className="h-5 w-5"
                />
                <span className="text-gray-700">New Messages</span>
              </div>
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  name="appUpdates"
                  checked={mobileSettings.appUpdates}
                  onChange={handleMobileCheckboxChange}
                  disabled={!mobileNotifications}
                  className="h-5 w-5"
                />
                <span className="text-gray-700">App Updates</span>
              </div>
              <div className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  name="nearbyOffers"
                  checked={mobileSettings.nearbyOffers}
                  onChange={handleMobileCheckboxChange}
                  disabled={!mobileNotifications}
                  className="h-5 w-5"
                />
                <span className="text-gray-700">Nearby Offers</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
